/** OWASP Top 10 category titles by code. */
const OWASP_TITLES: Record<string, string> = {
  // 2021
  'A01:2021': 'Broken Access Control',
  'A02:2021': 'Cryptographic Failures',
  'A03:2021': 'Injection',
  'A04:2021': 'Insecure Design',
  'A05:2021': 'Security Misconfiguration',
  'A06:2021': 'Vulnerable and Outdated Components',
  'A07:2021': 'Identification and Authentication Failures',
  'A08:2021': 'Software and Data Integrity Failures',
  'A09:2021': 'Security Logging and Monitoring Failures',
  'A10:2021': 'Server-Side Request Forgery',
  // 2017
  'A01:2017': 'Injection',
  'A02:2017': 'Broken Authentication',
  'A03:2017': 'Sensitive Data Exposure',
  'A04:2017': 'XML External Entities',
  'A05:2017': 'Broken Access Control',
  'A06:2017': 'Security Misconfiguration',
  'A07:2017': 'Cross-Site Scripting',
  'A08:2017': 'Insecure Deserialization',
  'A09:2017': 'Using Components with Known Vulnerabilities',
  'A10:2017': 'Insufficient Logging and Monitoring',
};

/**
 * Format an OWASP identifier for display.
 * If the value already contains a title (e.g. "A08:2021 - Software and Data Integrity Failures"),
 * return it as-is. Otherwise look up the title and append it.
 */
export function formatOwaspLabel(value: string): string {
  // Already has a title (contains " - ")
  if (value.includes(' - ')) return value;

  const title = OWASP_TITLES[value];
  return title ? `${value} - ${title}` : value;
}
